import script from "./shuibeng-config-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./shuibeng-config-dialog.vue?vue&type=script&setup=true&lang=js"

import "./shuibeng-config-dialog.vue?vue&type=style&index=0&id=3943358f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3943358f"]])

export default __exports__